import {z} from '@hono/zod-openapi';

/** A real Gregorian date in Honda's YYYYMMDD wire format, without timezone conversion. */
export const hondaReportDateSchema = z
  .string()
  .regex(/^\d{8}$/)
  .refine(
    (value) => {
      const year = Number(value.slice(0, 4));
      const month = Number(value.slice(4, 6));
      const day = Number(value.slice(6, 8));
      const leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
      const daysInMonth = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      return year >= 1000 && month >= 1 && month <= 12 && day >= 1 && day <= daysInMonth[month - 1];
    },
    {message: 'Expected a valid calendar date in YYYYMMDD format'}
  )
  .openapi('HondaReportDate');
